import React from "react";
import { Search, Users, MapPin, Handshake, Landmark } from "lucide-react";
import { Btn, SectionHeading } from "./ui";
import { Reveal } from "./useReveal";
import { LINKS } from "./data";

const CARDS = [
  { icon: Search, title: "Search Available Homes", desc: "Browse current listings through IDX and save the homes that fit your goals." },
  { icon: Users, title: "Local Buyer Agent", desc: "Connect with a Wallstreet Realty agent who knows Southern California markets." },
  { icon: MapPin, title: "Neighborhoods & Pricing", desc: "Understand communities and pricing so you can make an informed decision." },
  { icon: Handshake, title: "Offer & Negotiation", desc: "Get clear guidance on writing offers and negotiating with confidence." },
  { icon: Landmark, title: "Real Estate & Mortgage", desc: "Explore your real estate and mortgage options as part of one conversation." },
];

export const BuyerSection = () => (
  <section id="buy" className="py-16 lg:py-24 bg-white border-t border-[#F5F5F5]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionHeading
          eyebrow="For Buyers"
          title="Buy With Confidence"
          subtitle="Whether you are buying your first home, upgrading, downsizing, or investing, Wallstreet Realty helps you search smarter, understand your options, and move forward with a clear plan."
        />
      </Reveal>
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={i * 70}>
          <div
            data-testid={`buyer-card-${c.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className="lift h-full bg-white border border-[#E5E5E5] rounded-[20px] p-8 shadow-sm"
          >
            <div className="w-12 h-12 rounded-xl bg-[#254369]/8 flex items-center justify-center mb-5">
              <c.icon className="text-[#254369]" size={22} />
            </div>
            <h3 className="font-heading font-bold text-lg text-[#2D2D37]">{c.title}</h3>
            <p className="mt-2 text-[15px] leading-relaxed text-[#2D2D37]/65">{c.desc}</p>
          </div>
          </Reveal>
        ))}
      </div>
      <div className="mt-10 flex flex-wrap gap-3">
        <Btn href={LINKS.idx} variant="primary" testid="buyer-search-homes" pill>Search Homes</Btn>
        <Btn href={LINKS.buyers} variant="outline" testid="buyer-talk-agent">Talk to a Buyer Agent</Btn>
      </div>
    </div>
  </section>
);
